export enum ProgramTemplateMedicineTableColummDataIndex {
  ProtectedDrugName = "protectedDrugName",
  Type = "type",
  Inn = "inn",
}
